unit ConnectedCharitiesList;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, BaseList, WEBLib.ExtCtrls, WEBLib.Actions,
  Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.Grids, WEBLib.DBCtrls, Vcl.Controls, WEBLib.Lists,
  smx.webcore.types, WEBLib.WebCtrls;

type
  TConnectedCharitiesListForm = class(TBaseListForm)
    MainDatasetId: TIntegerField;
    MainDatasetDateAdded: TDateTimeField;
    MainDatasetAddedBy: TIntegerField;
    MainDatasetLastUpdatedBy: TIntegerField;
    MainDatasetLastUpdated: TDateTimeField;
    MainDatasetExternalId: TStringField;
    MainDatasetCharityTenant: TStringField;
    MainDatasetHMRCRef: TStringField;
    MainDatasetRegulatorNumber: TStringField;
    MainDatasetCharityName: TStringField;
    MainDatasetGAStatus: TStringField;
    RefreshTimer: TTimer;
    procedure AddButtonClick(Sender: TObject);
    procedure WebFormDestroy(Sender: TObject);
    procedure MainDatasetAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
    procedure MainDatasetAfterPost(DataSet: TDataSet);
    procedure RefreshTimerTimer(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure DataTableGetCellChildren(Sender: TObject; ACol, ARow: Integer;
      AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure MainDatasetAfterDelete(DataSet: TDataSet);
  private
    { Private declarations }
    FCharityIds: string;
  protected
    function GetEditFormClass: TFormClass; override;
    procedure PrepareForm; override;
    procedure LoadData; override;
    function RecordViewOption: TViewOption; override;
    procedure RefreshControls;
    function InitSortCol: Integer; override;
    function InitSortDirection: TSortDirection; override;
    function CreateGridInFormCreate: boolean; override;
    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);override;
    procedure DeleteSelectedRecord(RecordId: integer);
    function CheckOkToDelete(AConnectedCharityId: integer):boolean;
    [async]
    procedure GetConnectedCharityIdsWithClaims; async;
    [async]
    procedure AddConnectedCharity(AId: integer); async;
    [async]
    procedure EditRecord(const ARecordId: string); async; override;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  ConnectedCharitiesListForm: TConnectedCharitiesListForm;

implementation

{$R *.dfm}

uses
  ConnectedCharitiesEdit, SMX.Web.Layout.Utils, XData.Web.Client, MainDataModule;


procedure TConnectedCharitiesListForm.AddButtonClick(Sender: TObject);
begin
  AddConnectedCharity(0);
end;

procedure TConnectedCharitiesListForm.WebFormDestroy(Sender: TObject);
begin
  MainDataset.Active := false;
  inherited;
end;

function TConnectedCharitiesListForm.GetEditFormClass: TFormClass;
begin
  result := TConnectedCharityEditForm;
end;

procedure TConnectedCharitiesListForm.LoadData;
begin
  CreateGridPlugin;
  RefreshControls;
end;

procedure TConnectedCharitiesListForm.PrepareForm;
begin
  FIdField := 'Id';
end;

procedure TConnectedCharitiesListForm.WebFormShow(Sender: TObject);
begin
  inherited;
  GetConnectedCharityIdsWithClaims;
  LoadData;
end;

function TConnectedCharitiesListForm.RecordViewOption: TViewOption;
begin
  Result := TViewOption.voCreateAndEdit
end;

procedure TConnectedCharitiesListForm.RefreshControls;
begin
  FGridPlugin.Load;
end;

function TConnectedCharitiesListForm.InitSortCol: Integer;
begin
  result := 0;
end;

function TConnectedCharitiesListForm.InitSortDirection: TSortDirection;
begin
  result := sdAsc
end;

function TConnectedCharitiesListForm.CreateGridInFormCreate: boolean;
begin
  result := false;
end;

procedure TConnectedCharitiesListForm.MainDatasetAfterApplyUpdates(Sender:
    TDataSet; Info: TResolveResults);
begin
  inherited;
  RefreshControls;
end;

procedure TConnectedCharitiesListForm.MainDatasetAfterPost(DataSet: TDataSet);
begin
  inherited;
  MainDataset.ApplyUpdates;
  RefreshTimer.Enabled := true;
end;

procedure TConnectedCharitiesListForm.RefreshTimerTimer(Sender: TObject);
begin
  RefreshTimer.Enabled := false;
  RefreshControls;
end;

procedure TConnectedCharitiesListForm.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);

  procedure EditClick(Sender: TObject);
  begin
    EditRecord(TLayoutUtils.GetActionRecordId(Sender));
  end;

  procedure DeleteClick(Sender: TObject);
  begin
    DeleteSelectedRecord(TLayoutUtils.GetActionRecordIdInt(Sender));
  end;

var
  Span: THTMLSpan;
begin
  if (RecordViewOption in [voEdit, voCreateAndEdit]) then
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-edit', 'Edit');
    TLayoutUtils.SetActionRecordId(Span, ARecordId);
    Span.OnClick := @EditClick;
  end
  else if RecordViewOption = voReadOnly then
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-eye', 'View');
    TLayoutUtils.SetActionRecordId(Span, ARecordId);
    Span.OnClick := @EditClick;
  end;

  if ARecordId <> '' then
  begin
    if CheckOkToDelete(ARecordId.ToInteger) then
    begin
      Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-trash', 'Delete');
      TLayoutUtils.SetActionRecordId(Span, ARecordId);
      Span.OnClick := @DeleteClick;
    end;
  end;
end;

procedure TConnectedCharitiesListForm.DeleteSelectedRecord(RecordId: integer);
begin
  if MainDataSet.Locate('Id', RecordId, []) then
  begin
    try
      MainDataSet.Edit;
      MainDataSet.Delete;
    finally
      //MainDataSet.ApplyUpdates;
    end;
  end;
end;


procedure TConnectedCharitiesListForm.EditRecord(const ARecordId: string); {$IFDEF PAS2JS}async;{$ENDIF}
begin
  AddConnectedCharity(ARecordId.ToInteger);
end;

function TConnectedCharitiesListForm.CheckOkToDelete(AConnectedCharityId: integer):boolean;
var
  lId: string;
begin
  lId := Format('"%d"', [AConnectedCharityId]);
  result := Pos(lId, FCharityIds) = 0;
end;

procedure TConnectedCharitiesListForm.DataTableGetCellChildren(Sender: TObject;
    ACol, ARow: Integer; AField: TField; AValue: string; AElement:
    TJSHTMLElementRecord);
var
  RecordId: string;
begin
  if ARow = 0 then
    Exit;

  if DataTable.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := MainDataset.FieldByName(FIdField).AsString;
    AddRowActions(RecordId, AElement.Element);
  end;
end;

procedure TConnectedCharitiesListForm.GetConnectedCharityIdsWithClaims; {$IFDEF PAS2JS}async;{$ENDIF}
var
  lJobParams: JS.TJSObject;
  lRetval: TXDataClientResponse;
  lCharityIdsStr: string;
begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderUtilsService.RegisteredClaimsCharityId',[]));

  lCharityIdsStr := JS.ToString(lRetval.ResultAsObject['value']);
  FCharityIds := lCharityIdsStr;
end;

procedure TConnectedCharitiesListForm.MainDatasetAfterDelete(DataSet: TDataSet);
begin
  inherited;
  MainDataSet.ApplyUpdates;
end;

procedure TConnectedCharitiesListForm.AddConnectedCharity(AId: integer); {$IFDEF PAS2JS}async;{$ENDIF}
var
  Aform: TConnectedCharityEditForm;

begin
  AForm := TConnectedCharityEditForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.ElementClassName := 'PopUpForm';
    await(TForm, AForm.Load());
    if AId = 0 then
      MainDataSet.Insert
    else
    begin
      if not MainDataSet.Locate('Id', AId, []) then
      begin
        ShowMessage('The selected record could not be found. Please refresh the list and try again.');
        Exit;
      end;
    end;
    AForm.EditDataSet := MainDataSet;
    AForm.AfterCreated;
    await(TModalResult, AForm.Execute);
  finally
    if AForm.ModalResult = mrOk then
    begin
      MainDataSet.Post;
    end;
    AForm.Free;
    AForm := nil;
  end;
end;


procedure TConnectedCharitiesListForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  MainDatasetId := TIntegerField.Create(Self);
  MainDatasetDateAdded := TDateTimeField.Create(Self);
  MainDatasetAddedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdatedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdated := TDateTimeField.Create(Self);
  MainDatasetExternalId := TStringField.Create(Self);
  MainDatasetCharityTenant := TStringField.Create(Self);
  MainDatasetHMRCRef := TStringField.Create(Self);
  MainDatasetRegulatorNumber := TStringField.Create(Self);
  MainDatasetCharityName := TStringField.Create(Self);
  MainDatasetGAStatus := TStringField.Create(Self);
  RefreshTimer := TTimer.Create(Self);

  DataTable.BeforeLoadDFMValues;
  MainDataset.BeforeLoadDFMValues;
  MainDatasetId.BeforeLoadDFMValues;
  MainDatasetDateAdded.BeforeLoadDFMValues;
  MainDatasetAddedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdatedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdated.BeforeLoadDFMValues;
  MainDatasetExternalId.BeforeLoadDFMValues;
  MainDatasetCharityTenant.BeforeLoadDFMValues;
  MainDatasetHMRCRef.BeforeLoadDFMValues;
  MainDatasetRegulatorNumber.BeforeLoadDFMValues;
  MainDatasetCharityName.BeforeLoadDFMValues;
  MainDatasetGAStatus.BeforeLoadDFMValues;
  RefreshTimer.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnShow', 'WebFormShow');
    DataTable.Columns.Clear;
    with DataTable.Columns.Add do
    begin
      DataField := 'CharityName';
      Title := 'Charity Name';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'HMRCRef';
      Title := 'HMRC Ref';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'GAStatus';
      Title := 'External Ref';
    end;
    with DataTable.Columns.Add do
    begin
      Title := 'Actions';
    end;
    MainDataset.AfterApplyUpdates := MainDatasetAfterApplyUpdates;
    MainDataset.AfterDelete := MainDatasetAfterDelete;
    MainDataset.EntitySetName := 'ConnectedCharity';
    MainDatasetId.SetParentComponent(MainDataset);
    MainDatasetId.Name := 'MainDatasetId';
    MainDatasetId.FieldName := 'Id';
    MainDatasetDateAdded.SetParentComponent(MainDataset);
    MainDatasetDateAdded.Name := 'MainDatasetDateAdded';
    MainDatasetDateAdded.FieldName := 'DateAdded';
    MainDatasetAddedBy.SetParentComponent(MainDataset);
    MainDatasetAddedBy.Name := 'MainDatasetAddedBy';
    MainDatasetAddedBy.FieldName := 'AddedBy';
    MainDatasetLastUpdatedBy.SetParentComponent(MainDataset);
    MainDatasetLastUpdatedBy.Name := 'MainDatasetLastUpdatedBy';
    MainDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    MainDatasetLastUpdated.SetParentComponent(MainDataset);
    MainDatasetLastUpdated.Name := 'MainDatasetLastUpdated';
    MainDatasetLastUpdated.FieldName := 'LastUpdated';
    MainDatasetExternalId.SetParentComponent(MainDataset);
    MainDatasetExternalId.Name := 'MainDatasetExternalId';
    MainDatasetExternalId.FieldName := 'ExternalId';
    MainDatasetExternalId.Size := 64;
    MainDatasetCharityTenant.SetParentComponent(MainDataset);
    MainDatasetCharityTenant.Name := 'MainDatasetCharityTenant';
    MainDatasetCharityTenant.FieldName := 'CharityTenant';
    MainDatasetHMRCRef.SetParentComponent(MainDataset);
    MainDatasetHMRCRef.Name := 'MainDatasetHMRCRef';
    MainDatasetHMRCRef.FieldName := 'HMRCRef';
    MainDatasetRegulatorNumber.SetParentComponent(MainDataset);
    MainDatasetRegulatorNumber.Name := 'MainDatasetRegulatorNumber';
    MainDatasetRegulatorNumber.FieldName := 'RegulatorNumber';
    MainDatasetRegulatorNumber.Size := 40;
    MainDatasetCharityName.SetParentComponent(MainDataset);
    MainDatasetCharityName.Name := 'MainDatasetCharityName';
    MainDatasetCharityName.FieldName := 'CharityName';
    MainDatasetCharityName.Size := 255;
    MainDatasetGAStatus.SetParentComponent(MainDataset);
    MainDatasetGAStatus.Name := 'MainDatasetGAStatus';
    MainDatasetGAStatus.FieldName := 'GAStatus';
    MainDatasetGAStatus.Size := 10;
    RefreshTimer.SetParentComponent(Self);
    RefreshTimer.Name := 'RefreshTimer';
    RefreshTimer.Enabled := False;
    RefreshTimer.Interval := 3000;
    SetEvent(RefreshTimer, Self, 'OnTimer', 'RefreshTimerTimer');
    RefreshTimer.Left := 592;
    RefreshTimer.Top := 24;
  finally
    DataTable.AfterLoadDFMValues;
    MainDataset.AfterLoadDFMValues;
    MainDatasetId.AfterLoadDFMValues;
    MainDatasetDateAdded.AfterLoadDFMValues;
    MainDatasetAddedBy.AfterLoadDFMValues;
    MainDatasetLastUpdatedBy.AfterLoadDFMValues;
    MainDatasetLastUpdated.AfterLoadDFMValues;
    MainDatasetExternalId.AfterLoadDFMValues;
    MainDatasetCharityTenant.AfterLoadDFMValues;
    MainDatasetHMRCRef.AfterLoadDFMValues;
    MainDatasetRegulatorNumber.AfterLoadDFMValues;
    MainDatasetCharityName.AfterLoadDFMValues;
    MainDatasetGAStatus.AfterLoadDFMValues;
    RefreshTimer.AfterLoadDFMValues;
  end;
end;

end.
